<template>
  <div class="main-wrapper">
    <import-task ref="importTask">
      <template slot="header">
        <el-form :inline="true" size="mini">
          <span class="form-date-picker">
            <el-form-item label="日期:">
              <el-date-picker style="width: 150px" v-model="form.startDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="至" class="date-picker-middle">
              <el-date-picker style="width: 150px" v-model="form.endDateStr" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </span>
          <el-form-item style="float: right; margin-top: -1px">
            <button class="ioc-button i-mini i-success" @click="handleSearch">搜索</button>
          </el-form-item>
        </el-form>
      </template>
      <template slot="main-header">
        <el-button type="primary" size="mini" @click="showExport">批量导入 </el-button>
      </template>
    </import-task>
    <el-dialog :title="titleName" width="60%;" :visible.sync="dialogFormVisible" :close-on-click-modal="false">
      <div slot="footer" class="dialog-footer">
        <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="60px">
          <el-row>
            <el-col :span="24" align="left">
              <el-form-item label="附件" prop="goodsCode">
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  accept=".xls,.xlsx,.xls.ttt,.xlsx.ttt"
                  :limit="1"
                  action=""
                  :http-request="httpRequest"
                  :on-remove="handleRemove"
                  :headers="headers"
                  :file-list="fileList"
                  :on-success="handleSuccess"
                  :before-upload="beforeUpload"
                >
                  <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                  <el-button
                    style="margin-left: 10px"
                    v-loading.fullscreen.lock="fjLoading"
                    element-loading-text="数据导入中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)"
                    size="small"
                    type="success"
                    @click="checkFormValid"
                    >上传
                  </el-button>
                  <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且只能上传一个</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button @click="cancel" size="medium">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";
import moment from "moment";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  mixins: [pagePathMixin],
  data() {
    return {
      form: {
        startDate: "",
        endDate: "",
        endDateStr: "",
        reportName: "",
        appCode: "ec-pc-new",
      },
      dialogFormVisible: false,
      titleName: "",
      requestParam: {},
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      rules: {
      },
      fjLoading: false,
      options: [],
      storeName: "",
    };
  },
  computed: {},
  methods: {
    handleSearch() {
      console.log(this.$refs["importTask"].propList);
      this.form.endDate = this.form.endDateStr == null || this.form.endDateStr == "" ? this.form.endDateStr : this.form.endDateStr.substr(0, 10) + " 23:59:59";
      this.$refs["importTask"].init(this.form);
    },
    showExport() {
      this.fileList = [];
      this.dialogFormVisible = true;
      let filename = this.$route.query.fileName;
      filename = filename.substring(0, filename.lastIndexOf("."));
      this.titleName = filename + "批量维护";
    },
    cancel() {
      this.dialogFormVisible = false;
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      console.log(file, fileList);
    },
    httpRequest(file) {},
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.cancel();
      this.handleSearch();
    },
    // 验证
    beforeUpload(file) {
      // .xls,.xlsx,.xls.ttt,.xlsx.ttt
      let pattern = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (["xls", "xlsx", "xls.ttt", "xlsx.ttt"].indexOf(pattern.toLowerCase()) === -1) {
        this.$message.error("请上传后缀名为.xls,.xlsx的附件！");
        return false;
      }
      this.fileList = [];
      this.fileList.push(file);
    },
    checkFormValid(file) {
      this.$refs["requestParam"].validate((valid) => {
        if (valid) {
          this.submitUpload(file);
        } else {
          this.$message.error("参数校验失败！");
        }
      });
    },
    submitUpload(file) {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error("请先上传Excel附件");
        return;
      }
      this.fjLoading = true;

      let taskDTO = null;
      let fields = [
      ];
      taskDTO = {
        reportName: this.form.reportName,
        appCode: "ec-pc-new",
        paramMap: fields, //预销计划 fields
      };

      this.$q.common
        .uploadFile({
          data: {
            file: this.fileList[0],
            taskDTO: JSON.stringify(taskDTO),
          },
        })
        .then((res) => {
          if (res.success) {
            this.$message.success("数据导入中，请稍后");
          } else {
            this.$message.error(res.message);
          }
          this.fjLoading = false;
          this.cancel();
          this.handleSearch();
        });
      // this.$refs.upload.submit();
    },
  },
  mounted() {
    this.form.reportName = "prePlanUnAssessGoodsImport";
    this.handleSearch();
  },
};
</script>

<style lang="stylus" scoped>
.main-wrapper
  height calc(100vh - 85px)
>>> .el-header
  padding 10px
  .el-form-item
    margin-bottom 10px
</style>
